import {createAction, props} from '@ngrx/store';
import {
  AuthorizePaymentResponse, BasePurchaseOutputInterface,
  CreditCardPaymentResponse, CreditCardPurchaseInputModel,
  PaymentProfileCollection,
  PurchaseInputModel,
  ValidateCreditCardPaymentModel
} from '@app/marketplace/checkout/_models/payment-profile.model';
import {ResponseModel} from '@app/marketplace/core/models/response.model';
export const LOADING_PAYMENT_PROFILES = '[Payments_Profile] Loading payments profile';
export const LIST_PAYMENTS_PROFILE = '[Payments_Profile] List payments profile';
export const PURCHASE_TOKEN = '[Payment_Profile_Purchase] Purchase with token';
export const PURCHASE_NEW_CARD = '[Payment_Profile_Purchase] Purchase with new card';
export const PAYMENT_RESPONSE = '[Payment_Profile_Purchase] Payment response';
export const VALIDATING_CARD = '[Payment_Profile_Validate] Validating card';
export const VALIDATING_3D_SECURE_CARD = '[Payment_Profile_Validate] Validating 3D secure card';
export const VALIDATE_CARD_RESPONSE = '[Payment_Profile_Validate] Validated card response';
export const CANCELING_PAYMENT = '[Payment_Profile_Cancel] Canceling payment';
export const CANCELED_PAYMENT = '[Payment_Profile_Cancel] Canceled payment';
export const CLEAR_PAYMENT = '[Payment_Profile] Clear payment';
export const CANCEL_PAYMENT_PROFILES_REQUEST = '[Payments_Profile] cancel request';
export const ERROR_PAYMENT_PROFILES_REQUEST = '[Payments_Profile] Payments profile request error';
export const CLOSE_ERROR_MESSAGE = '[Payment_Profile] Close error message';

export const LoadingPaymentsProfile = createAction(
  LOADING_PAYMENT_PROFILES
);
export const ListPaymentsProfile = createAction(
  LIST_PAYMENTS_PROFILE,
  props<{ data: PaymentProfileCollection}>()
);
export const ValidatingCard = createAction(
  VALIDATING_CARD,
  props<{payload: ValidateCreditCardPaymentModel}>()
);
export const Validating3DSecureCard = createAction(
  VALIDATING_3D_SECURE_CARD,
  props<{orderCode: string; externalData: string; }>()
);
export const ValidatedCardResponse = createAction(
  VALIDATE_CARD_RESPONSE,
  props<{data: AuthorizePaymentResponse}>()
);
export const PurchaseToken = createAction(
  PURCHASE_TOKEN,
  props<{payload: PurchaseInputModel}>()
);
export const PurchaseNewCard = createAction(
  PURCHASE_NEW_CARD,
  props<{payload: CreditCardPurchaseInputModel}>()
);
export const PaymentResponse = createAction(
  PAYMENT_RESPONSE,
  props<{data: CreditCardPaymentResponse}>()
);
export const CancelingPayment = createAction(
  CANCELING_PAYMENT,
  props<{orderCode: string, token: string}>()
);
export const ClearPayment = createAction(
  CLEAR_PAYMENT);
export const CanceledPayment = createAction(
  CANCELED_PAYMENT,
  props<{data: ResponseModel<BasePurchaseOutputInterface>}>()
);
export const CancelPaymentsProfileRequest = createAction(
  CANCEL_PAYMENT_PROFILES_REQUEST
);
export const CloseErrorMessage = createAction(
  CLOSE_ERROR_MESSAGE);
